<template>
    <div class="page">
        <div class="page-text-wrap">
            <h1>DING DONG – Dette er markedsinformationen</h1>
            <p>Vi vil løbende igennem Vorbasse Hjemmemarked 2020 annoncere via notifikationer inde på vores digitale markedsplads.</p>
            <p>Klik dig rundt og lad universet folde sig ud – Prøv tivoliet og se om du er heldig at vinde præmier, gå i ølteltet og hør live musik fra hammer gode kunstnere eller slå et smut forbi boderne, hvor kræmmerne sidder klar på den anden side af skærmen for at snakke med dig og lave en god handel.</p>
            <h2>Savner du også Vorbasse Marked?</h2>
            <p>Vi glæder os helt vildt til 2021, men indtil da så må vi have en fest hjemme – hver for sig. Nedenfor kan du læse lidt om det som gør Vorbasse Marked til netop Vorbasse Marked – vi glæder os til at feste med dig de næste par dage – og vender stærkt tilbage i 2021!</p>
            <p>Læs blandt andet om...</p>
            <ul>
                <li><router-link to="historie">Vores historie</router-link></li>
                <li><router-link to="kraemmerne">Kræmmerne</router-link></li>
                <li><router-link to="heste-og-smaadyr">Heste og Smådyr</router-link></li>
                <li><router-link to="de-farende-svende">De farende svende</router-link></li>
                <li><router-link to="camping">Camping</router-link></li>
            </ul>
            <h2>Har du brug for hjælp?</h2>
            <p>Vi er tilstede – ligesom vi plejer – fang os enten via facebook eller ring til os på telefon: <strong>75 33 36 56</strong></p>
            <button class="facebook" @click="confirmClickToExternal('https://www.facebook.com/vorbassemarked')">Markedsinformationen på Facebook</button>
        </div>
    </div>
</template>

<script>
	import confirmClickToExternal from "@/mixins/confirmClickToExternal";
	export default {
		name: "Markedsinfo.vue",
		mixins:[confirmClickToExternal],
	}
</script>
